import { Resource as i, API as h } from "@coveo/platform-client";
const s = class s extends i {
  /**
   * Get product listing metrics
   * @param productListingId
   * @param options
   * @returns ProductListingMetricsBaseModel
   */
  get(t, e) {
    return this.api.get(
      this.buildPath(`${s.baseUrl}/${t}`, e)
    );
  }
  /**
   * Get product listing product metrics
   * @param productListingId
   * @param options
   * @returns ProductListingMetricsProductPageModel
   */
  getProducts(t, e) {
    return this.api.get(
      this.buildPath(`${s.baseUrl}/${t}/products`, e)
    );
  }
  /**
   * Get product listing product metric by product id
   * @param productListingId
   * @param productId
   * @param options
   * @returns ProductListingMetricsProductModel
   */
  getProduct(t, e, a) {
    return this.api.get(
      this.buildPath(
        `${s.baseUrl}/${t}/products/${e}`,
        a
      )
    );
  }
  /**
   * Get product listing metrics by organization
   * @param options
   * @returns ProductListingMetricsPageModel
   */
  list(t) {
    return this.api.get(
      this.buildPath(`${s.baseUrl}`, t)
    );
  }
};
s.baseUrl = `/rest/organizations/${h.orgPlaceholder}/commerce/reports/v1/productListings`;
let r = s;
export {
  r as ProductListingReportingMetrics
};
//# sourceMappingURL=ProductListingReportingMetrics.js.map
